import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DadosService } from '../../db/dados.service';
import { Localidades, ILocalidades } from '../../../../models/localidades.model';
import { getTableNameFull } from '../../../../models/data.model';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { UsersService } from '../../../../models/usuarios.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  fLocalidadeNome: string;
  nickName: string = '';
  eventUserLogin: Subscription;
  @Output() sidenavToggle = new EventEmitter<void>();
  @Output() sidenavChat = new EventEmitter<void>();


  constructor(private dados: DadosService,
    private users: UsersService,
    private router: Router) {
    this.eventUserLogin = users.loginChange.subscribe(d => {
      this.mudaNickName();
    })


  }

  mudaNickName() {
    try {
      if (this.users.logado) {
        var names: string[] = [];
        names = this.users.usuario.nome.split(' ');
        if (names.length)
          this.nickName = names[0];
      }
    } catch (err) {
      this.dados.errorLog('app','nickname',err);
    }
  }

  ngOnInit() {
    if (this.users.logado)
      this.mudaNickName();
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.eventUserLogin) this.eventUserLogin.unsubscribe();
  }

  gotoHome() {
    this.dados.regAnalytics(0, 'acessos', 'home', 1);
    this.router.navigate(['/']);
  }

  login(){
    this.router.navigate(['/login']);
  }

  get localidades() {
    return this.dados.localidades;
  }
  get localidadeNome() {
    return this.dados.localidadeNome;
  }
  set localidadeNome(x) {
    this.dados.localidadeNome = x;
  }

  onToggleSidenav() {
    this.dados.regAnalytics(0, 'acessos', 'menu', 1);
    this.sidenavToggle.emit();
  }
  onChatMessage() {
    this.sidenavChat.emit();
  }

  showInfo(texto: any) {

  }
  getCount() {
    return this.dados.getCount();
  }
  getItensCountLabel() {
    var rt = this.getCount();
    return (rt > 0 ? rt : '');
  }

  doCarrinhoClick() {

  }

  getCurrentDir() {
    return this.dados.getCurrentDir();
  }
  @Input()
  get nomeLoja() {
    return environment.site.nome;
  }
  get logo() {
    return environment.site.logo;
  }

  goMenu() {
    this.dados.regAnalytics(0, 'acessos', 'nomeLoja', 1);
    this.router.navigate(['/menu']);
  }
  getNickName() {
    return this.nickName;
  }

}
